import 'css/src/components/public-pages/TripleCard';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import ContentfulImageOrVideo from 'js/src/components/public-pages/ContentfulImageOrVideo';
import type { ImmutableMap } from 'js/src/libs/consts';
import type { ContentfulImageOrVideoData } from 'js/src/libs/contentful-utils';

type Props = {
    data: ImmutableMap<{
        image1: ContentfulImageOrVideoData;
        subheading1: string;
        title1: Document;
        url1: string;
        cta_text1: string;
        image2: ContentfulImageOrVideoData;
        subheading2: string;
        title2: Document;
        url2: string;
        cta_text2: string;
        image3: ContentfulImageOrVideoData;
        subheading3: string;
        title3: Document;
        url3: string;
        cta_text3: string;
    }>;
    bgColor: string;
    lazyLoad: boolean;
};

const TripleCard = React.memo(function TripleCard({ data, bgColor, lazyLoad }: Props) {
    const nodeList = [];
    for (let i = 0; i < 3; i++) {
        const image = data.get(`image${i + 1}` as 'image1' | 'image2' | 'image3');
        const subheading = data.get(
            `subheading${i + 1}` as 'subheading1' | 'subheading2' | 'subheading3',
        );
        const title = data.get(`title${i + 1}` as 'title1' | 'title2' | 'title3');
        const url = data.get(`url${i + 1}` as 'url1' | 'url2' | 'url3');
        const ctaText = data.get(`cta_text${i + 1}` as 'cta_text1' | 'cta_text2' | 'cta_text3');

        if (image && title) {
            // image and title are required
            let subheadingNode = null;
            if (subheading) {
                subheadingNode = <p className="card-title">{subheading}</p>;
            }

            let ctaNode = null;
            if (ctaText) {
                ctaNode = <p className="card-cta text-end font-l5 font-l5--small">{ctaText}</p>;
            }

            nodeList.push(
                <div className="col-sm-4" key={i}>
                    <div className="card">
                        <a href={url}>
                            <ContentfulImageOrVideo
                                className="card-img-top"
                                data={image}
                                urlWidth={300}
                                style={{
                                    borderTopLeftRadius: 10,
                                    borderTopRightRadius: 10,
                                    borderBottomRightRadius: 0,
                                    borderBottomLeftRadius: 0,
                                }}
                                lazyLoad={lazyLoad}
                            />
                            <div className="card-body">
                                {subheadingNode}
                                <div className="card-text">
                                    {documentToReactComponents(title.toJS())}
                                </div>
                                {ctaNode}
                            </div>
                        </a>
                    </div>
                </div>,
            );
        }
    }
    return (
        <div className="contentful-component triple-card" style={{ backgroundColor: bgColor }}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-10 offset-sm-1">
                        <div className="row">{nodeList}</div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default TripleCard;
